/**
 * Warunki programu „Przydomowe Magazyny Energii 2” (PME2, NFOŚiGW) do raportu „Sprawdź ofertę”.
 *
 * ═══ TO JEST PLIK DO RĘCZNEJ EDYCJI ═══
 * Źródło: regulamin naboru PME część 2 (FM), wrzesień 2026, ogłoszenie o naborze (załącznik 1),
 * strony „O programie” i „Jak uzyskać dofinansowanie” oraz wzór protokołu odbioru z 22.10.2026
 * (przydomowemagazyny.gov.pl), stan na 2026-10-09; FAQ (premia UE, pytanie 22) i formularz z pokazu NFOŚiGW 2026-10-19. Opracowanie: `VV/dane_badawcze/pme2/`.
 * Przy zmianie regulaminu albo wzorów popraw liczby tutaj i w artykule, i zmień `STAN_PME2`.
 */

/** Data stanu wiedzy, pokazywana w raporcie. */
export const STAN_PME2 = '2026-10-19'

/** Nabór ciągły w GWD (gwd.nfosigw.gov.pl), do tej daty albo do wyczerpania 1 mld zł. */
export const NABOR_OD = '2026-10-20'
export const NABOR_DO = '2027-10-01'

/** Koszty kwalifikowane od tej daty; do dnia wniosku sprzęt kupiony, zamontowany, opłacony i zgłoszony do OSD. */
export const KOSZTY_OD = '2025-11-01'

/**
 * Premia za sprzęt z UE: do 2 000 zł, gdy falownik hybrydowy (konieczny do pracy magazynu)
 * albo magazyn wyprodukowano w UE, tylko za jedno urządzenie. Kraj sprawdzają ze zdjęcia
 * tabliczki znamionowej.
 */
export const PREMIA_UE = 2000

/**
 * Dotacja do magazynu razem z premią UE: najwyżej 50% kosztów kwalifikowanych magazynu energii,
 * także gdy premia jest za falownik (FAQ PME2, pytanie 22, odczyt 2026-10-19; program 7.2 pkt 3).
 */
export const LIMIT_Z_PREMIA_UDZIAL_MAGAZYNU = 0.5

/** Razem na jeden punkt poboru energii (magazyn energii, premia UE, magazyn ciepła). */
export const LIMIT_NA_PPE = 19000

export const ARTYKUL_PME2 = {
  href: '/baza-wiedzy/dotacja-na-magazyn-energii-pme2',
  tytul: 'Dotacja na magazyn energii 2026: do 16 000 zł z programu PME2',
}

/** Najmniejsza pojemność NOMINALNA magazynu (wersja konsultacyjna mówiła 12 kWh). */
export const MIN_POJEMNOSC_KWH = 10

/** Zasada 2:1: pojemność w Wh co najmniej dwa razy większa niż moc PV w Wp (przez cały okres trwałości). */
export const KWH_NA_KWP = 2

/**
 * Cena zakupu i montażu magazynu za kWh, bez falownika i EMS. Wzór protokołu odbioru (22.10.2026,
 * pkt 2.B.1 1.1) każe wpisać kwoty BRUTTO z faktur i przy nich podaje ten limit, więc liczymy z VAT.
 */
export const MAKS_CENA_ZA_KWH = 3000

/** Dotacja: najniższa z trzech wartości. */
export const PROCENT_KOSZTOW = 0.30
export const ZL_ZA_KWH = 800
export const LIMIT_NET_BILLING = 16000
export const LIMIT_NET_METERING = 8000
